import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="h-[50px] w-full  text-blue-500 z-40 flex items-center justify-center space-x-2 font-bold text-center text-[22px] mb-6 relative">
      <span>
        <i className="bi-heart-pulse-fill"></i>
      </span>
      <span>MusicLab</span>
    </header>
  );
}

export default Header;
